module.exports = __webpack_public_path__ + "static/sheep7-e861759df9e777f41287b3a4422e9dfd.jpeg";